module.exports = __webpack_public_path__ + "img/international_bottle.20c80399.png";